import "@/App.css";
import { useEffect } from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import LandingPage from "@/components/LandingPage";
import PascoaPage from "@/components/PascoaPage";
import PascoaProductPage from "@/components/PascoaProductPage";
import ScrollToTop from "@/components/ScrollToTop";
import { Toaster } from "@/components/ui/sonner";
import { CartProvider } from "@/context/CartContext";
import { Analytics } from "@vercel/analytics/react";
import { trackEvent } from "@/lib/analytics";

function App() {
  useEffect(() => {
    trackEvent("site_loaded", {
      source: "app_mount",
    });
  }, []);

  return (
    <CartProvider>
      <div className="App">
        <BrowserRouter>
          <ScrollToTop />
          <Routes>
            <Route path="/" element={<LandingPage />} />
            <Route path="/pascoa" element={<PascoaPage />} />
            <Route path="/pascoa/:productId" element={<PascoaProductPage />} />
          </Routes>
        </BrowserRouter>
        <Analytics />
        <Toaster position="top-right" />
      </div>
    </CartProvider>
  );
}

export default App;
